export default {
  order_again: 'Commander à nouveau',
  error_messages: {
    product_does_not_exist: "Le produit n'est plus disponible",
  },
  success_messages: {
    product_added_to_card: 'Produit ajouté au panier',
  },
};
